// extracted by mini-css-extract-plugin
module.exports = {"button":"InvoicesToggleShownPopup_button_1KMqJ"};